import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../../HelmetWrapper";
import { selectUser } from "../../../components/auth/auth.selector";
import CommonStructured from "../../../components/common-components/CommonStructured";
import { fetchDefferedApprovalsData } from "../../../redux/payment-reducerss/paymentSlice";
import DFApprovalListings from "../../../components/deffered-payments/deffered-approvals/DFApprovalListings";
import CmnFilters from "../../../components/lead-management/common/CmnFilters";
import { isManagerRole as checkIsManagerRole } from "../../../components/common-data/Conversions";

const DFApprovals = ({ isOutSource }) => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { dfApprovalsLoading } = useSelector((state) => state.plans);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedFitnessProfileStatus: "",
    selectedApprovalStatus: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    document_status: allFilters.selectedFitnessProfileStatus?.value || "",
    approval_status: allFilters.selectedApprovalStatus?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getDefferedApprovalListings(filters) {
    dispatch(
      fetchDefferedApprovalsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getDefferedApprovalListings(filters);
  }, [filters]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      document_status: allFilters.selectedFitnessProfileStatus?.value || "",
      approval_status: allFilters.selectedApprovalStatus?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedFitnessProfileStatus,
    allFilters.selectedApprovalStatus,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Couple Membership Request">
      <Container
        className={`bg-cloud-k ${
          isOutSource ? "p-0" : "px-50px"
        } gobal-container`}
        fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Couple Membership Request"}
              isReload={() => getDefferedApprovalListings(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"couple-membership-request"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={dfApprovalsLoading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <DFApprovalListings
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              isFirstColSticky={true}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              callFunction={() => getDefferedApprovalListings(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DFApprovals;
